import { createSlice } from "@reduxjs/toolkit";

import { type RegistrationGroupStateType } from "../interfaces";

const initialState: RegistrationGroupStateType = {
  isLoading: false,
  registrationGroups: [],
};

const registrationGroupSlice = createSlice({
  name: "registrationGroup",
  initialState,
  reducers: {
    setRegistrationGroupLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setRegistrationGroup: (state, action) => {
      state.registrationGroups = action.payload;
    },
  },
});

export const { setRegistrationGroupLoading, setRegistrationGroup } =
  registrationGroupSlice.actions;
export default registrationGroupSlice.reducer;
